import ResetUpdatePassContainer from '../../../../Containers/AdminContainer/Auth/ResetPassword/updatePassword';

const ResetUpdatePassScreen = () => {
  return <ResetUpdatePassContainer />;
};
export default ResetUpdatePassScreen;
